import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output, SimpleChanges, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LastLoggedInUser, DecodedToken } from '@core/models';
import { BrandResult, GetProductsQuery, ProductReturnModel, SkuResult } from '@core/services/api.service';
import { Observable } from 'rxjs';
import { CategoryModel } from '@core/models/categories';
import { Store } from '@ngxs/store';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-product-brands',
    templateUrl: './product-brands.component.html',
    styleUrls: ['./product-brands.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductBrandsComponent implements OnInit {
    @Input() brands: BrandResult[];
    @Output() brandClicked = new EventEmitter<string>();
    isDrawerOpen: boolean = false;
    returnUrl: string;
    currentUrl: string;
    constructor(
        private router: Router
    ) { }


    ngOnInit() {
        this.currentUrl = this.router.url;
    }

    filterByBrand(name: string) {
        this.brandClicked.emit(name);
    }

    clearBrand() {
        this.brandClicked.emit();
        this.closeDrawer();
    }

    onClick(event: Event) {
        event.preventDefault();
    }

    openDrawer() {
        this.isDrawerOpen = true;
    }

    closeDrawer() {
        this.isDrawerOpen = false;
    }

    toggleDrawer() {
        this.isDrawerOpen = !this.isDrawerOpen;
    }
}
